import { Controller, useFormContext } from 'react-hook-form';
import { DatePickerField, IDatePickerField } from '../DatePickerField/DatePickerField';

interface IFormDateInputProps extends Omit<IDatePickerField, 'onDateChange' | 'date'> {
  name: string;
  errorTouchedOnly?: boolean;
  onChange?: (value: string | Date | null) => void;
  disabled?: boolean;
  disableFormOnChange?: boolean;
}

export const FormDateInput = ({
  errorTouchedOnly,
  onChange,
  disableFormOnChange,
  ...props
}: IFormDateInputProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field: { onBlur, value, ref, ...field }, fieldState, formState }) => {
        const showError = (formState.isSubmitted || fieldState.invalid) && !!fieldState.error;
        const helperText = props.helperText || fieldState.error?.message || '';

        const handleChange = (value: string | Date | null) => {
          onChange?.(value);
          !disableFormOnChange && field.onChange(value);
        };

        return (
          <DatePickerField
            {...props}
            date={value || null}
            inputRef={ref}
            onDateChange={handleChange}
            error={showError}
            helperText={helperText}
            dataTestId={props.dataTestId ?? field.name}
          />
        );
      }}
    />
  );
};
